import { render, staticRenderFns } from "./BlackCurrentConsume.vue?vue&type=template&id=2fd2f3cc&scoped=true&"
import script from "./BlackCurrentConsume.vue?vue&type=script&lang=js&"
export * from "./BlackCurrentConsume.vue?vue&type=script&lang=js&"
import style0 from "./BlackCurrentConsume.vue?vue&type=style&index=0&id=2fd2f3cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2f3cc",
  null
  
)

export default component.exports